<template>
  <ul
    class="list-unstyled m-0"
    role="list"
  >
    <li class="flex py-1 px-3 relative items-center">
      <router-link
        :to="{ name: 'aboutUsPath' }"
        class="block pt-2 pr-2 pb-2 pl-0 text-sm uppercase flex-grow-1 leading-sm stretched-link"
      >
        {{ t('about_us') }}
      </router-link>
      <i class="mi-chevron-r icon-12" />
    </li>
    <li class="flex py-1 px-3 relative items-center border-top">
      <router-link
        :to="{ name: 'faqPath' }"
        class="block pt-2 pr-2 pb-2 pl-0 text-sm uppercase flex-grow-1 leading-sm stretched-link"
      >
        {{ t('faq') }}
      </router-link>
      <i class="mi-chevron-r icon-12" />
    </li>
    <li class="flex py-1 px-3 relative items-center border-top">
      <router-link
        :to="{ name: 'contactPath' }"
        class="block pt-2 pr-2 pb-2 pl-0 text-sm uppercase flex-grow-1 leading-sm stretched-link"
      >
        {{ t('contact') }}
      </router-link>
      <i class="mi-chevron-r icon-12" />
    </li>
    <li
      v-if="locale !== 'ro' && locale !== 'hu' && locale !== 'de'"
      class="flex py-1 px-3 relative items-center border-top"
    >
      <router-link
        :to="{ name: 'distributorsPath' }"
        class="block pt-2 pr-2 pb-2 pl-0 text-sm uppercase flex-grow-1 leading-sm stretched-link"
      >
        {{ t('distributors') }}
      </router-link>
      <i class="mi-chevron-r icon-12" />
    </li>
    <li
      v-if="locale === 'cs'"
      class="flex py-1 px-3 relative items-center border-top"
    >
      <router-link
        :to="{ name: 'jobOfferPath' }"
        class="block pt-2 pr-2 pb-2 pl-0 text-sm uppercase flex-grow-1 leading-sm stretched-link"
      >
        {{ t('parttimejob') }}
      </router-link>
      <i class="mi-chevron-r icon-12" />
    </li>

    <li class="flex py-1 px-3 relative items-center border-top">
      <router-link
        :to="{ name: 'blogPath' }"
        class="block pt-2 pr-2 pb-2 pl-0 text-sm uppercase flex-grow-1 leading-sm stretched-link"
      >
        {{ t('blog') }}
      </router-link>
      <i class="mi-chevron-r icon-12" />
    </li>
    <li class="flex py-1 px-3 relative items-center border-top">
      <router-link
        :to="{ name: 'mixitAfiliatePath' }"
        class="block pt-2 pr-2 pb-2 pl-0 text-sm uppercase flex-grow-1 leading-sm stretched-link"
      >
        {{ t('loyalty_program') }}
      </router-link>
      <i class="mi-chevron-r icon-12" />
    </li>
    <li class="flex py-1 px-3 relative items-center border-top">
      <router-link
        :to="{ name: 'complaintsPath' }"
        class="block pt-2 pr-2 pb-2 pl-0 text-sm uppercase flex-grow-1 leading-sm stretched-link"
      >
        {{ t('complaint') }}
      </router-link>
      <i class="mi-chevron-r icon-12" />
    </li>
  </ul>
  <div v-if="locale !== 'ro' && locale !== 'hu'">
    <p class="h5 px-3 pt-4 mb-1">
      {{ t('for_companies') }}
    </p>
    <ul
      class="list-unstyled m-0"
      role="list"
    >
      <li class="flex py-1 px-3 relative items-center">
        <router-link
          :to="{ name: 'companyGiftsPath' }"
          class="block pt-2 pr-2 pb-2 pl-0 text-sm uppercase flex-grow-1 leading-sm stretched-link"
        >
          {{ t('company_gifts') }}
        </router-link>
        <i class="mi-chevron-r icon-12" />
      </li>
      <li v-if="locale !== 'de'" class="flex py-1 px-3 relative items-center border-top">
        <a
          :href="t('wholesale_link')"
          class="block pt-2 pr-2 pb-2 pl-0 text-sm uppercase flex-grow-1 leading-sm stretched-link"
        >
          {{ t('wholesale') }}
        </a>
        <i class="mi-chevron-r icon-12" />
      </li>
    </ul>
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { useI18n } from 'vue-i18n'

import { useAppStore } from '@/stores/AppStore'

const { t, locale } = useI18n()

const appStore = useAppStore()

const { isSignedIn } = storeToRefs(appStore)
</script>

<i18n>
  {
    "cs": {
    "about_us": "O nás",
    "blog": "Blog",
    "collect_credits": "Sbírat kredity",
    "company_gifts": "Firemní dárky",
    "complaint": "Reklamace",
    "contact": "Kontakt",
    "distributors": "Kde jsme",
    "faq": "Otázky (FAQ)",
    "for_companies": "Pro firmy",
    "loyalty_program": "Věrnostní program",
    "parttimejob": "Práce / brigáda",
    "wholesale": "Velkoobchod",
    "wholesale_link": "https://velkoobchod.mixit.cz/"
},
    "sk": {
    "about_us": "O nás",
    "blog": "Blog",
    "collect_credits": "Zbierať kredity",
    "company_gifts": "Firemné darčeky",
    "complaint": "Reklamácia",
    "contact": "Kontakt",
    "distributors": "Kde sme",
    "faq": "Otázky (FAQ)",
    "for_companies": "Pre firmy",
    "loyalty_program": "Vernostný program",
    "parttimejob": "Práca / brigáda",
    "wholesale": "Veľkoobchod",
    "wholesale_link": "https://velkoobchod.mixit.sk/"
},
    "pl": {
    "about_us": "O nas",
    "blog": "Blog",
    "collect_credits": "Zbieraj punkty",
    "company_gifts": "Prezenty firmowe",
    "complaint": "Reklamacja",
    "contact": "Kontakt",
    "distributors": "Gdzie jesteśmy",
    "faq": "Pytania (FAQ)",
    "for_companies": "Dla firm",
    "loyalty_program": "Program lojalnościowy",
    "parttimejob": "Kariera w Mixit",
    "wholesale": "Hurtownia",
    "wholesale_link": "https://hurtownia.mixit.pl/"
},
    "hu": {
    "about_us": "Rólunk",
    "blog": "Blog",
    "collect_credits": "Kreditek",
    "company_gifts": "Céges ajándékok",
    "complaint": "Reklamáció",
    "contact": "Kapcsolat",
    "distributors": "Kik vagyunk",
    "faq": "Kérdések (GYIK)",
    "for_companies": "Cégek számára",
    "loyalty_program": "Hűségprogram",
    "parttimejob": "Állás / Részmunkaidő",
    "wholesale": "Nagykereskedés",
    "wholesale_link": "https://velkoobchod.mixit.cz/"
},
    "de": {
    "about_us": "Über uns",
    "blog": "Blog",
    "collect_credits": "Punkte sammeln",
    "company_gifts": "Firmengeschenke",
    "complaint": "Reklamation",
    "contact": "Kontakt",
    "distributors": "Wo wir sind",
    "faq": "Fragen (FAQ)",
    "for_companies": "Für Unternehmen",
    "loyalty_program": "Treueprogramm",
    "parttimejob": "Stellenangebote",
    "wholesale": "Großhandel",
    "wholesale_link": "https://grosshandel.mixit.de/"
},
    "at": {
    "about_us": "Über uns",
    "blog": "Blog",
    "collect_credits": "Punkte sammeln",
    "company_gifts": "Firmengeschenke",
    "complaint": "Reklamation",
    "contact": "Kontakt",
    "distributors": "Wo wir sind",
    "faq": "Fragen (FAQ)",
    "for_companies": "Für Unternehmen",
    "loyalty_program": "Treueprogramm",
    "parttimejob": "Stellenangebote",
    "wholesale": "Großhandel",
    "wholesale_link": "https://grosshandel.mixit.de/"
},
    "ro": {
    "about_us": "Despre noi",
    "blog": "Blog",
    "collect_credits": "Adună credite",
    "company_gifts": "Cadouri corporative",
    "complaint": "Reclamații",
    "contact": "Contact",
    "distributors": "Cine suntem",
    "faq": "Întrebări (FAQ)",
    "for_companies": "Pentru firme",
    "loyalty_program": "Program de loialitate",
    "parttimejob": "",
    "wholesale": "Angro",
    "wholesale_link": "https://velkoobchod.mixit.cz/"
}
  }
</i18n>
